/**
 * Klaviyo Back in Stock — client-side subscription API.
 * @see https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const KLAVIYO_BACK_IN_STOCK_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions';
const KLAVIYO_REVISION = '2025-10-15';
export class KlaviyoConfigError extends Error {
}
export class KlaviyoRequestError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}
/** Public company_id from the `klaviyo_company_id` theme setting (window.liquidCustom.klaviyoCompanyId). */
export function getKlaviyoCompanyIdFromScript() {
    var _a;
    if (typeof window === 'undefined')
        return '';
    return (((_a = window.liquidCustom) === null || _a === void 0 ? void 0 : _a.klaviyoCompanyId) || '').trim();
}
export function subscribeToBackInStock(_a) {
    return __awaiter(this, arguments, void 0, function* ({ email, shopifyVariantId, }) {
        const companyId = getKlaviyoCompanyIdFromScript();
        if (!companyId) {
            throw new KlaviyoConfigError('Could not resolve Klaviyo company_id from the onsite script.');
        }
        if (!shopifyVariantId) {
            throw new KlaviyoConfigError('Missing Shopify variant ID.');
        }
        if (!email) {
            throw new KlaviyoConfigError('Missing email.');
        }
        const payload = {
            data: {
                type: 'back-in-stock-subscription',
                attributes: {
                    channels: ['EMAIL'],
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: { email },
                        },
                    },
                },
                relationships: {
                    variant: {
                        data: {
                            type: 'catalog-variant',
                            id: `$shopify:::$default:::${shopifyVariantId}`,
                        },
                    },
                },
            },
        };
        const url = `${KLAVIYO_BACK_IN_STOCK_URL}/?company_id=${encodeURIComponent(companyId)}`;
        const res = yield fetch(url, {
            method: 'POST',
            headers: {
                'content-type': 'application/vnd.api+json',
                accept: 'application/vnd.api+json',
                revision: KLAVIYO_REVISION,
            },
            body: JSON.stringify(payload),
        });
        if (!(res.ok || res.status === 202)) {
            throw new KlaviyoRequestError(yield extractKlaviyoErrorMessage(res), res.status);
        }
    });
}
/** Surfaces Klaviyo's JSON:API error detail (e.g. "Invalid phone number.") when present. */
function extractKlaviyoErrorMessage(res) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const body = yield res.json();
            const detail = (_b = (_a = body === null || body === void 0 ? void 0 : body.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.detail;
            if (typeof detail === 'string' && detail.trim())
                return detail;
        }
        catch (_c) {
            // not JSON — fall through to the generic message
        }
        return `Klaviyo back-in-stock request failed: ${res.status} ${res.statusText}`;
    });
}
